import { commonChecks } from '@xhs/ozone-detector'

import { appVersionGte } from './version'

const canShareMp = (commonChecks.isAndroid && appVersionGte('5.20')) || true

const SET_SHARE_INFO = 'setShareInfo'
const CHANGE_TITLE = 'changeTitle'

function postNotice({ methodName, data }) {
  const wxBridge = (typeof window === 'object' && typeof window.wx === 'object') ? window.wx : null

  if (!wxBridge
    || !wxBridge.miniProgram
    || !wxBridge.miniProgram.postMessage
  ) {
    return Promise.resolve()
  }

  wxBridge.miniProgram.postMessage({
    data: {
      methodName,
      data,
    },
  })

  return Promise.resolve()
}

function changeTitle(title = '') {
  const data = {
    title,
  }

  return postNotice({
    methodName: CHANGE_TITLE,
    data,
  })
}

function setShareInfo(data) {
  return postNotice({
    methodName: SET_SHARE_INFO,
    data,
  })
}

export {
  canShareMp,
  changeTitle,
  setShareInfo,
}
